import { render, staticRenderFns } from "./tickets-top-filters.vue?vue&type=template&id=0151cb87"
import script from "./tickets-top-filters.vue?vue&type=script&lang=js"
export * from "./tickets-top-filters.vue?vue&type=script&lang=js"
import style0 from "./tickets-top-filters.vue?vue&type=style&index=0&id=0151cb87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports